import gameConfig from "../../../gameConfig";
import { getKeyPair } from "../../../helpers/gameHelpers";

export const checkAnswerIsAlreadyUsed = (keysPressed, key) => {
  const pairKey = getKeyPair(key);
  if (keysPressed.includes(pairKey)) {
    return true;
  }
};

export const checkScoreForGameEnd = (score) => {
  let isGameEnd = false;
  // End game if count of answers of at least one player crosses the limit
  if (
    score.player1.answers.length >= gameConfig.answersCount ||
    score.player2.answers.length >= gameConfig.answersCount
  ) {
    isGameEnd = true;
  }
  // End game if a player is already won by score
  const player1FreeSlots =
    gameConfig.answersCount - score.player1.answers.length;
  const player2FreeSlots =
    gameConfig.answersCount - score.player2.answers.length;
  if (
    player2FreeSlots + score.player2.score < score.player1.score ||
    player1FreeSlots + score.player1.score < score.player2.score
  ) {
    isGameEnd = true;
  }
  return isGameEnd;
};
